import React from 'react'

export interface NewWikiValues {
  newWikiCount: number
  setRefetchFlag: React.Dispatch<React.SetStateAction<boolean>>
}
export interface NewNewsValues {
  newNewsCount: number
  setRefetchFlag: React.Dispatch<React.SetStateAction<boolean>>
}
export const NewWikisContext = React.createContext<NewWikiValues>(null as any)
export const NewNewsContext = React.createContext<NewNewsValues>(null as any)
